import { UserAndTenantDto } from '@zorro/clients';
import { SUCCESS_MESSAGES } from '@zorro/common-utils';
import { Stack, Text } from '@zorro/web/design-system';
import { useMonolithMutation } from '@zorro/web/ui-utils';
import pluralize from 'pluralize';

import { ModalFooter } from '../../../index';
import { RecordForActions } from '../EmployeeActionsUtils';

type AccountInvitationFormProps = {
  recordsForActions: RecordForActions[];
  onClose: () => void;
  onSuccess: () => void;
};

const AccountInvitationForm = ({
  recordsForActions,
  onClose,
  onSuccess,
}: AccountInvitationFormProps) => {
  const { tryMutate: sendActivationEmails } = useMonolithMutation({
    method: 'usersControllerSendActivationEmails',
    successMessage: SUCCESS_MESSAGES.getEmailSentSuccessfullyMessage(
      recordsForActions.length
    ),
  });
  const isSingleEmployee = recordsForActions.length === 1;

  async function handleSubmit() {
    const userIds: UserAndTenantDto[] = recordsForActions.map((record) => ({
      id: record.userId,
      tenantId: record.employerId,
    }));

    await sendActivationEmails([userIds]);
    onSuccess();
  }

  const text = isSingleEmployee
    ? 'Are you sure you want to send this email to the selected employee?'
    : 'Are you sure you want to send this email to all selected employees?';

  const submitText = `Send ${pluralize('email', recordsForActions.length)}`;

  return (
    <Stack gap="xxl">
      <Text>{text}</Text>
      <ModalFooter
        onClose={onClose}
        submitVariant="primary"
        submitText={submitText}
        onSubmit={handleSubmit}
      />
    </Stack>
  );
};

export { AccountInvitationForm };
